import React, {FC, useState, useCallback, useContext} from "react";
import {Box, StandardTextFieldProps, TextField} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {IconContext} from "@buildwitt/shapeshift-identity";

const useStyles = makeStyles()((theme) => ({
	input: {
		width: "100%"
	},
	icon: {
		cursor: "pointer"
	},
	timeStampInputAdornment: {
		marginRight: theme.spacing(1.5)
	},
	sendButtonInputAdornment: {
		marginTop: theme.spacing(0.75),
		height: "100%",
		alignSelf: "end"
	}
}));

interface ICustomProps {
	onPostNote: (note: string) => void,
	initialValue: string,
	disableTimeStamp?: boolean
}

export type IProps = StandardTextFieldProps & ICustomProps;

export const NoteInput:FC<IProps> = ({onPostNote, placeholder = "Type your private note", className, initialValue = "", ...baseProps}) => {
	const {classes, cx} = useStyles();
	const [note, setNote] = useState<string>(initialValue);
	const {icon} = useContext(IconContext);

	const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setNote(event.target.value);
	}, [setNote]);

	const handleSubmit = useCallback(() => {
		if (!note) {
			return;
		}

		onPostNote(note);
		setNote("");
	}, [note, setNote, onPostNote]);

	return (
		<TextField
			className={cx(classes.input, className)}
			placeholder={placeholder}
			data-test-id="note-input"
			multiline
			InputProps={{
				disableUnderline: true,
				autoCapitalize: "none",
				autoComplete: "off",
				endAdornment: (
					<Box className={classes.sendButtonInputAdornment}>
						{icon("sendOutlinedIcon", {
							"data-test-id": "note-input-submit-btn",
							className: classes.icon,
							onClick: handleSubmit
						})}
					</Box>
				)
			}}
			value={note}
			onChange={handleChange}
			{...baseProps}
		/>
	);
};